import { xhrRequest } from '../../shared/helpers';

export default class extends Controller {
  static targets = ['cardsContainer'];

  connect() {
    this.calculateWidthAndSetPerPage();
    this.cardsContainerTarget.classList.remove('shift-forward', 'shift-back');
    setTimeout(this.removeOldCardsContainer.bind(this), 1000);
    this.loadContentFromServerOnConnect && this.initialLoad();
    this.attachStatusButtonClickHandler();
    App.QuickAdd.addToAfterQuickAdd(this.initialLoad.bind(this));
  }

  //
  // ACTIONS
  //

  loadNewStatus(event) {
    this.loadCardsFromServer(null, event.detail.url);
  }

  loadNewPage(event, url=null) {
    url = url || (event && event.currentTarget.dataset.url);
    if (url) {
      this.loadCardsFromServer(event, url, event && event.currentTarget.dataset.direction);
    }
  }

  //
  // INTERNAL USE
  //

  initialLoad() {
    this.cardsContainerTarget.innerHTML = `
      <div class="cards-container--component">
        ${Array.from({ length: this.perPage }, () => this.dummyCard).join('')}
      </div>
    `;
    this.loadCardsFromServer();
  }

  loadCardsFromServer(event, url, direction=null) {
    event && event.preventDefault();
    this.cardsContainerTarget.classList.add('is-loading');
    App.Helpers.appendContent(this.cardsContainerTarget, this.dataLoadingHTML);
    xhrRequest(url || this.fetchURL, 'get')
      .then(({ data }) => {
        direction ? this.slideContentIn(data, direction) : App.Helpers.replaceElement(this.element, data);
      });
  }

  attachStatusButtonClickHandler() {
    if (this.shouldAttachStatusButtonClickHandler) {
      App.Helpers.listenToCustomEvent(document, 'status-button-click', this.loadNewStatus.bind(this));
    }
  }

  slideContentIn(html, direction) {
    const oldCards = this.cardsContainerTarget.querySelector('.cards-container--component:not(.old-content)');
    oldCards.classList.add(direction === 'forward' ? 'before' : 'after', 'old-content');
    const newHTML = document.createElementFromString(html);
    const newSection = newHTML.querySelector('.card-row');
    newSection[direction === 'forward' ? 'prepend' : 'append'](oldCards);
    newSection.classList.add(`shift-${direction}`);
    App.Helpers.replaceElement(this.element, newHTML);
  }

  removeOldCardsContainer() {
    const elToRemove = this.element.querySelector('.old-content');
    elToRemove && elToRemove.remove();
  }

  calculateWidthAndSetPerPage() {
    const elementSize = this.element.offsetWidth;
    this.perPage = this.getPerPage(elementSize);
  }

  getPerPage(size) {
    if (size < 700) return 1;
    if (size >= 700 && size < 1000) return 2;
    if (size >= 1000 && size < 1300) return 3;
    if (size >= 1300 && size < 1600) return 4;
    return 5;
  }

  //
  // GETTERS AND SETTERS
  //

  get fetchURL() {
    return this.data.has('fetch-url') ? App.Helpers.addParamsToURL(this.data.get('fetch-url'), { per_page: this.perPage }) : '';
  }

  get loadContentFromServerOnConnect() {
    return ['1', true, 'true'].indexOf(this.data.get('load-content-from-server')) > -1;
  }

  get perPage() {
    return parseInt(this.data.get('per-page')) || 5;
  }

  set perPage(num) {
    this.data.set('per-page', num);
  }

  get dataLoadingHTML() {
    return '<div class="loading-indicator"><div class="data-loading"></div></div>';
  }

  get shouldAttachStatusButtonClickHandler() {
    return ['1', true, 'true'].indexOf(this.data.get('attach-status-change-handler')) > -1;
  }

  get dummyCard() {
    return `
      <div class="activity-card dummy-card">
        <div class="card-title">
          <div class="dummy-content"></div>
        </div>
        <div class="activity-meta">
          <div class="dummy-content"></div>
          <div class="dummy-content"></div>
          <div class="dummy-content"></div>
          <div class="dummy-content"></div>
          <div class="dummy-content"></div>
          <div class="dummy-content"></div>
        </div>
      </div>
    `;
  }
};



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/shared/horizontal-card-section-controller.js